
import Cell from './Cell';
import Form from './CellForm';

Cell.Form = Form;

export default Cell;



// WEBPACK FOOTER //
// ./components/Cell/index.js